import { render, staticRenderFns } from "./ChangelogPage.vue?vue&type=template&id=4aeb0e62&"
import script from "./ChangelogPage.vue?vue&type=script&lang=js&"
export * from "./ChangelogPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4aeb0e62')) {
      api.createRecord('4aeb0e62', component.options)
    } else {
      api.reload('4aeb0e62', component.options)
    }
    module.hot.accept("./ChangelogPage.vue?vue&type=template&id=4aeb0e62&", function () {
      api.rerender('4aeb0e62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ChangelogPage.vue"
export default component.exports